var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.criteria.length
    ? _c(
        "div",
        { attrs: { "data-qa": "patient_profile_critera_list" } },
        [
          _vm._l(_setup.criteriaTrust, function (criterion, index) {
            return _c(
              "div",
              {
                key: criterion,
                staticClass: "d-flex align-center",
                class: { "mt-3": index !== 0 },
              },
              [
                _c("div", {
                  staticClass:
                    "ui-icon-fz-medium mr-3 success--text ui-icon-check-circle",
                }),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "text-body-1",
                    attrs: { "data-qa": "patient_profile_criterion" },
                  },
                  [_vm._v("\n      " + _vm._s(criterion) + "\n    ")]
                ),
              ]
            )
          }),
          _vm._v(" "),
          _setup.criteriaWithoutTrust.length > 0 &&
          _setup.criteriaTrust.length > 0
            ? _c("div", { staticClass: "mb-6" })
            : _vm._e(),
          _vm._v(" "),
          _vm._l(_setup.criteriaWithoutTrust, function (criterion, index) {
            return _c(
              "div",
              {
                key: criterion,
                staticClass: "d-flex align-center",
                class: { "mt-3": index !== 0 },
              },
              [
                _c("div", {
                  staticClass:
                    "ui-icon-fz-medium mr-3 warning--text ui-icon-circle-warning",
                }),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "text-body-1",
                    attrs: { "data-qa": "patient_profile_criterion" },
                  },
                  [_vm._v("\n      " + _vm._s(criterion) + "\n    ")]
                ),
              ]
            )
          }),
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }